import { Coordinate } from "@nova/protobuf"
import { runTask } from "@nova/webworker-pool"
import { mergeIntersectingPolygons } from "./merge-intersecting-polygons"

export { mergeIntersectingPolygons }

export const mergePolygonsIfTheyIntersect = async (
    polygons: Coordinate[][],
    abortSignal?: AbortSignal
): Promise<Coordinate[][]> => {
    if (polygons.length < 2) return polygons.filter((e) => e.length > 2)

    // Convert Coordinate[] to [number, number][] for clipper union.
    const inputPolygons: [number, number][][] = polygons
        .filter((polygon) => polygon.length >= 3)
        .map((polygon) =>
            polygon.map((coord) => [coord.longitude, coord.latitude] as [number, number])
        )

    const mergedPolygons = await runTask(
        mergeIntersectingPolygons,
        { polygons: inputPolygons, precision: 6 },
        { signal: abortSignal }
    )

    // Convert back to Coordinate[].
    const result: Coordinate[][] = mergedPolygons
        .filter((ring: [number, number][]) => ring.length >= 3)
        .map((ring: [number, number][]) => {
            // Remove the closing point if it exists (Clipper closes rings).
            const points = ring.slice()
            const first = points[0]
            const last = points[points.length - 1]
            if (first[0] === last[0] && first[1] === last[1]) {
                points.pop()
            }
            return points.map(([longitude, latitude]: [number, number]) => ({
                longitude,
                latitude,
            }))
        })

    return result
}
